import { render, staticRenderFns } from "./user_center_rights.vue?vue&type=template&id=19d380ce&scoped=true"
import script from "./user_center_rights.vue?vue&type=script&lang=js"
export * from "./user_center_rights.vue?vue&type=script&lang=js"
import style0 from "./user_center_rights.css?vue&type=style&index=0&id=19d380ce&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d380ce",
  null
  
)

export default component.exports